import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import {UtilService} from "../../../shared/services/util.service";
import {setoresModuleName, setoresStorage} from "../shared/data.service";
import {estruturasModuleName} from "../../shared/data.service";
import {editRoute, newRoute} from "../../../shared/services/data.service";
import {Setor} from "../shared/setor.model";
import {SetorApiService} from "../shared/setor-api.service";
import { SetorService } from "../shared/setor.service";
import {AutoCompleteService} from "../../../shared/components/autocomplete/autocomplete.service";
import {Divisao} from "../../divisoes/shared/divisao.model";
import {DivisaoNavigationService} from "../../divisoes/shared/divisao-navigation.service";
import {SetorNavigationService} from "../shared/setor-navigation.service";
import {DivisaoApiService} from "../../divisoes/shared/divisao-api.service";
import {divisoesStorage, divisoesQuery} from "../../divisoes/shared/data.service";

@Component({
  template: require('./setor-form.component.html'),
  styles: [require('./setor-form.component.css')]
})
export class SetorFormComponent implements OnInit {
  estruturasModule:any = estruturasModuleName;
  setoresModule:any = setoresModuleName;
  formObject:any = new Setor();
  divisaoObject:any = new Divisao();
  actionTitle:string;
  submitted:boolean = false;
  btnSaveDisabled:boolean = false;
  showSelectDivisao:boolean = false;

  divisaoSelectId:string = 'divisaoSelect';
  divisaoQuery:any = divisoesQuery;

  form:FormGroup;
  ativo = new FormControl('');
  setor = new FormControl('', Validators.required);
  divisao = new FormControl('');

  private returnToOtherForm:boolean = false;
  private otherForm:string;
  private responsSetor:any;

  constructor(
    private _route:ActivatedRoute,
    private _utilService:UtilService,
    private _setoreservice: SetorService,
    private _setorApiService: SetorApiService,
    private _setorNavigationService: SetorNavigationService,
    private _divisaoNavigationService: DivisaoNavigationService,
    private _divisaoApiService: DivisaoApiService,
    private _autocompleteService:AutoCompleteService,
    private _fb:FormBuilder
  ) {
    this.form = _fb.group({
      ativo: this.ativo,
      setor: this.setor,
      divisao: this.divisao
    });
  }

  ngOnInit() {
    this.isNewAutoComplete();
  }

  clickGoToList() {
    this.goToList();
  }

  clickCancel() {
    this.toLeaveHere();
  }

  onSubmit(evt: any) {
    this.submitted = true;
    if(evt.valid) {
      this.btnSaveDisabled = true;
      var object:Setor = this._utilService.cloneObject(this.formObject);

      if (this.divisaoObject.id) {
        object.divisaoId = this.divisaoObject.id;
      } else {
        this.btnSaveDisabled = false;
        return false;
      }

      if (this.formObject.id) {
        this.onEditSetor(object);
      } else {
        this.onAddSetor(object);
      }
    }
  }

  getDivisoesObject(object: any) {
    if(object.novo) {
      var thisFormObject: any = this.formObject;
      thisFormObject.divisao = this.divisaoObject;

      this._setoreservice.setSessionStorage(thisFormObject);

      var toOtherFormObject: any = {
        divisao: object.text,
        form: setoresStorage
      };
      this._autocompleteService.setSessionStorage(toOtherFormObject, divisoesStorage);
      this._divisaoNavigationService.goToNew();
    } else {
      this.divisaoObject = object;
      this._utilService.setSelectOnFormControl(this.form, 'divisao', object);
    }
  }

  private onAddSetor(object: Setor) {
    this._setorApiService.onPost(object, this.onDone);
  }

  private onEditSetor(object: Setor) {
    this._setorApiService.onPut(object, this.onDone);
  }

  private onDone = (function (Response: any) {
    if (!Response.error)  {
      this.responsSetor = Response;
      if (this.formObject.id) {
        this._utilService.swalMessageEditSuccess();
      } else {
        this._utilService.swalMessageAddSuccess();
      }
      this.toLeaveHere();
    } else {
      this.btnSaveDisabled = false;
      this._utilService.swalMessageWarningCustom(Response.error);
    }
  }.bind(this));

  private getObject(id: number) {
    var onDone = (function(Response: any) {
      if (!Response.error)  {
        this.formObject = Response;
        this.setModelToForm();
      } else {
        this._utilService.swalMessageWarningCustom('Nenhum setor encontrado com este id.');
        this.toLeaveHere();
      }
    }.bind(this));

    this._setorApiService.onGetById(id, onDone);
  }

  private setModelToForm() {
    if (this.formObject.divisao) {
      this.divisaoObject = this.formObject.divisao;
      delete this.formObject['divisao'];

      var selectObject:any = {text: this.divisaoObject.divisao, id: this.divisaoObject.id};

      this._autocompleteService.createOptionOnSelect2(this.divisaoSelectId, selectObject);
      this._autocompleteService.setValueOnSelect2(selectObject.id, this.divisaoSelectId);
      this._utilService.setSelectOnFormControl(this.form, 'divisao', this.divisaoObject);
    }
  }

  private goToList() {
    this._setoreservice.clearSessionStorage();
    this._setorNavigationService.goToList();
  }

  private testSession() {
    var id: number;
    var session: any = this._setoreservice.getSessionStorage();
    this._setoreservice.clearSessionStorage();

    if (session) {
      this.formObject = session;
      id = session.id;
      if (id) {
        this.setEditSession();
      } else {
        this.setNewSession();
      }
    } else {
      id = +this._route.snapshot.params['id'];
      if (id) {
        this.setEditNormal(id);
      } else {
        this.setNewNormal();
      }
    }

    this.setActionTitle(id);
  }

  private setActionTitle(id: any) {
    if (id) {
      this.actionTitle = editRoute;
    } else {
      this.actionTitle = newRoute;
    }
  }

  private setEditNormal(id: number) {
    this.showSelectDivisao = true;
    this.getObject(id);
  }

  private setNewNormal() {
    //se tiver alguma configuração inicial de um cadastro novo
    this.divisaoObject = this._setoreservice.getSessionStorageFatherModule();
    this.setModelToForm();
  }

  private setEditSession() {
    //qndo retornou para continuar a edição
    this.showSelectDivisao = true;
    setTimeout(function () {
      this.setModelToForm();
    }.bind(this));
  }

  private setNewSession() {
    //qndo retornou para continuar o cadastro
    this.setModelToForm();
  }

  private isNewAutoComplete() {
    var newAutoComplete: any = this._autocompleteService.getSessionStorage(setoresStorage);
    if (newAutoComplete) {
      this.returnToOtherForm = true;
      this.otherForm = newAutoComplete.form;
      this.formObject.setor = newAutoComplete.setor;
      this.showSelectDivisao = true;

      this.setActionTitle(this.formObject.id);
    } else {
      //retornando de um cadastro
      this.testSession();
    }
  }

  private toLeaveHere() {
    if (this.returnToOtherForm) {
      this._setoreservice.returnToOtherForm(this.otherForm, this.responsSetor);
    } else {
      this.goToList();
    }
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/setores/setor-form/setor-form.component.ts
 **/